module.exports = __webpack_public_path__ + "static/media/favicon.a031bdae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/favicon.svg
// module id = 802
// module chunks = 0